import { Injectable } from '@angular/core';

@Injectable()
export class LookAndFillStoreService {
  private readonly smallFontSize = 12;
  private readonly mediumFontSize = 14;
  private readonly bigFontSize = 16;
  private _fontSize = this.smallFontSize;
  private _isLightTheme = true;

  get isLightTheme(): boolean {
    return this._isLightTheme;
  }

  get fontSize(): number {
    return this._fontSize;
  }

  get isSmallFontSelected(): boolean {
    return this._fontSize === this.smallFontSize;
  }

  get isMediumFontSelected(): boolean {
    return this._fontSize === this.mediumFontSize;
  }

  get isBigFontSelected(): boolean {
    return this._fontSize === this.bigFontSize;
  }

  constructor() {}

  setLightTheme() {
    this._isLightTheme = true;
  }

  setDarkTheme() {
    this._isLightTheme = false;
  }

  setFontSize(fontSize: number) {
    this._fontSize = fontSize;
  }

  setSmallFont() {
    this._fontSize = this.smallFontSize;
  }

  setMediumFont() {
    this._fontSize = this.mediumFontSize;
  }

  setBigFont() {
    this._fontSize = this.bigFontSize;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/look-and-fill-store/look-and-fill-store.service.ts